import { days } from '../Config/League/league.config'

export const checkLastUserDataPromptShown = () => {
  const localStorage = window.localStorage
  const lastShown = localStorage.getItem('lastShownUserUpdatePrompt')
  if (!lastShown) {
    return true
  }
  const timestamp = parseInt(lastShown)
  const delta = new Date().getTime() - timestamp
  if (delta > 864000000) {
    //10 days in miliseconds
    return true
  }
  return false
}

export const setLastSeenInStorage = (name: string) => {
  const time = new Date().getTime()
  const timeStr = time.toString()
  const localStorage = window.localStorage
  localStorage.setItem(name, timeStr)
}

export const hasNotStarted = (timestamp: number) => {
  const time = new Date().getTime() / 1000
  const delta = timestamp - time
  if (delta > 0) {
    //Not started yet
    return true
  }
  return false
}

export const isPastTime = (timestamp: number) => {
  const time = new Date().getTime() / 1000
  const delta = timestamp - time
  if (delta < 0) {
    //Past time
    return true
  }
  return false
}

/**
 *
 * Checking if day has changed, used for preventing action for 1 day
 */
export const isNextDay = (storageId: string) => {
  const localStorage = window.localStorage
  const storedDay = localStorage.getItem(storageId)
  if (!storedDay) {
    return true
  }
  const dayNum = new Date().getDay()
  const day = days[dayNum]
  if (storedDay === day) {
    //Same day, day did not change
    return false
  }
  return true
}

/**
 *
 * Checking if day has changed, used for preventing action for 1 day
 */
export const isBetweenDates = (start: number, end: number) => {
  const now = new Date().getTime() / 1000
  if (now > start && now < end) {
    //In between time range
    return true
  }
  return false
}

/**
 *
 * Checking if object or arrays are same using deep equal
 */
export const isDeepEqual = (obj1: any, obj2: any) => {
  if (typeof obj1 !== typeof obj2) {
    return false
  }
  if (typeof obj1 === 'object' && obj1 !== null) {
    return JSON.stringify(obj1) === JSON.stringify(obj2)
  }
  return obj1 === obj2
}

/**
 *
 * For delaying functions
 */
export function debouncePromise(fn: any, time: number) {
  let timerId: any = undefined

  return function debounced(...args: any) {
    if (timerId) {
      clearTimeout(timerId)
    }

    return new Promise((resolve, reject) => {
      timerId = setTimeout(async () => {
        try {
          const result = await fn(...args)
          resolve(result)
        } catch (error) {
          reject(error)
        }
      }, time)
    })
  }
}
